import Application from "../../Application";
import { IAuthenticationService } from "../../service/authentication/AuthenticationService";
import { IUserService } from "../../service/user/UserService";

export default class ResetPasswordInteractor {
  private application: Application;
  private authenticationService: IAuthenticationService;
  private userService: IUserService;

  constructor(application, authenticationService, userService) {
    this.application = application;
    this.authenticationService = authenticationService;
    this.userService = userService;
  }

  async execute(username: string) {
    return this.authenticationService.resetPassword(username);
  }
}
